module.exports = __webpack_public_path__ + "static/media/logo-disney.5452f2c2.png";